export enum BluecodeEventType {
  Unavailable,
  PaymentRegistered,
  PaymentRequestConfirmation,
  PaymentCompleted,
  PaymentAborted,
  RevertTransactionCompleted,
  RevertTransactionFailed,
}
